module.exports = __webpack_public_path__ + "static/media/Ross2.bf799dab.png";